import { useRouter } from 'next/router'
import { ReactNode } from 'react'

import { Card } from 'src/components/atoms/Card'
import { Heading1 } from 'src/components/atoms/Typography'
import { Tabs } from 'src/components/molecules/Tabs'

import { PlantingType } from 'src/types/planting'

import { AdminPlantingNavTab, getTabs } from './helper'

export interface AdminPlantingNavProps {
  activeTab: AdminPlantingNavTab
  children: ReactNode
  planting: PlantingType
  tabs: any[]
}

export const Layout = ({
  activeTab,
  children,
  planting,
  tabs
}: AdminPlantingNavProps) => {
  const router = useRouter()

  const handleChangeTab = (tab: string) => {
    if (tab === activeTab) return

    const selectedTab = tabs.find(t => t.value === tab)

    if (selectedTab) {
      router.push(selectedTab?.path)
    }
  }

  return (
    <>
      <Heading1>{planting?.Name || 'Planting'}</Heading1>
      <Card size='small' className='overflow-x-scroll'>
        <div className='flex justify-between items-center pr-4'>
          <Tabs
            className='mx-4 mt-2'
            tabs={tabs}
            onChange={handleChangeTab}
            activeTab={activeTab}
            ariaLabel='Application navigation'
          />
        </div>
        <div className='p-4'>{children}</div>
      </Card>
    </>
  )
}

export const AdminPlantingNav = (
  props: Omit<AdminPlantingNavProps, 'tabs'>
) => {
  const { planting } = props
  const tabs = getTabs(planting)

  return <Layout {...props} planting={planting} tabs={tabs} />
}
